import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { fetchConsent } from "redux/features/consent/consentThunk"
import { ConsentType } from "types"

const consentAdapter = createEntityAdapter({
  selectId: (consent: ConsentType) => consent.client_id,
})

export const initialState = consentAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const consentSlice = createSlice({
  name: "consent",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchConsent.pending, (state) => handleFetchPending(state))
      .addCase(fetchConsent.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchConsent.fulfilled, (state, { payload }) => {
        consentAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectConsentById } = consentAdapter.getSelectors(
  (state: RootState) => state.features.consent,
)
export const selectFetchStatus = (state: RootState) =>
  state.features.consent.fetchStatus

export default consentSlice.reducer
